/* eslint-disable import/no-default-export */
import Chance from 'chance';
const chance = new Chance();

export default () =>
  chance.pickone([
    {
      option: {
        id: '2',
        description: 'Less than one year',
      },
      newToWorkforce: false,
    },
    {
      option: {
        id: '3',
        description: '1 year',
      },
      newToWorkforce: false,
    },
    {
      option: {
        id: '7',
        description: '5 years',
      },
      newToWorkforce: false,
    },
    {
      option: null,
      newToWorkforce: true,
    },
    {
      option: null,
      newToWorkforce: false,
    },
  ]);
